import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import 'react-aspect-ratio/aspect-ratio.css';
import { MultiIcon } from '@infl-ts/ui-advocate-icons';
import { getExpirationWithinWeek } from '@infl-ts/util-date';
import { useChallengePlayer } from '@infl-ts/util-use-challenge-player';
import { Warning as WarningIcon } from '@mui/icons-material';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { Box } from '@mui/material';
import { parseISO } from 'date-fns';
import * as A from 'fp-ts/Array';
import { constFalse, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as Pred from 'fp-ts/Predicate';
import { Translation, useTranslation } from 'react-i18next';
import { match, P } from 'ts-pattern';
import { hasCompletionsLeft, hasMemberCompletionsLeft } from '../activity-selector/activity-action';
import { ProgressBar } from '../progress-bar';
import { RouterLink } from '../router-link';
import { Tooltip } from '../tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var allActivitiesClosed = function allActivitiesClosed(challenge) {
  var _challenge$activities;

  return pipe((_challenge$activities = challenge.activities) !== null && _challenge$activities !== void 0 ? _challenge$activities : [], O.fromPredicate(A.isNonEmpty), O.map(A.every(function (x) {
    return x.state === 'closed';
  })), O.getOrElse(constFalse));
};

var isMulticomplete = function isMulticomplete(challenge) {
  return !!challenge.multiComplete;
};

var checkIfComplete = pipe(isMulticomplete, Pred.and(hasCompletionsLeft), Pred.and(hasMemberCompletionsLeft), Pred.not, Pred.and(allActivitiesClosed));

var CompletionWarning = function CompletionWarning(_ref) {
  var remainingCompletionCount = _ref.remainingCompletionCount;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "CompletionWarning",
    "data-source-file": "status-bar.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: t("remainingCompletionCountText", {
          count: remainingCompletionCount
        }),
        arrow: true,
        children: /*#__PURE__*/_jsx(WarningIcon, {
          color: "warning",
          fontSize: "inherit",
          sx: {
            mr: 0.5
          }
        })
      });
    }
  });
};

var MulticompleteInfo = function MulticompleteInfo(_ref2) {
  var memberRemainingCompletionCount = _ref2.memberRemainingCompletionCount;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "MulticompleteInfo",
    "data-source-file": "status-bar.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: completionMessage(memberRemainingCompletionCount, t),
        arrow: true,
        children: /*#__PURE__*/_jsx(Box, {
          sx: {
            height: 16,
            display: 'flex',
            alignItems: 'center'
          },
          children: /*#__PURE__*/_jsx(MultiIcon, {
            "aria-label": "Multi complete challenge",
            fontSize: "inherit",
            sx: {
              mr: 0.5
            }
          })
        })
      });
    }
  });
};

var completionMessage = function completionMessage(remainingMemberCompletionsCount, t) {
  if (remainingMemberCompletionsCount === null) return t("You can complete this challenge multiple times");
  return t('remainingMemberCompletionsCount', {
    count: remainingMemberCompletionsCount
  });
};

var TimeUntilExpiration = function TimeUntilExpiration(_ref3) {
  var timeUntilExpiration = _ref3.timeUntilExpiration;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "TimeUntilExpiration",
    "data-source-file": "status-bar.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: t("Expiring in {{timeUntilExpiration}}", {
          timeUntilExpiration: timeUntilExpiration
        }),
        arrow: true,
        children: /*#__PURE__*/_jsx(AccessTimeFilledIcon, {
          color: "error",
          fontSize: "inherit",
          sx: {
            mr: 0.5
          }
        })
      });
    }
  });
};

var ChallengeProgress = function ChallengeProgress(_ref4) {
  var challenge = _ref4.challenge;

  var _useChallengePlayer = useChallengePlayer(),
      getCurrentActivity = _useChallengePlayer.getCurrentActivity;

  var currentActivityStatus = getCurrentActivity(challenge);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return pipe(match(currentActivityStatus)["with"]({
    _tag: 'cannot-start'
  }, {
    _tag: 'can-start'
  }, function () {
    return 0;
  })["with"]({
    _tag: 'can-continue',
    activity: {
      currentStage: P.select()
    }
  }, function (stage) {
    return stage == null ? 0 : Math.trunc(stage.position * 100 / challenge.totalStages);
  }).exhaustive(), function (progress) {
    return progress === 0 ? null : /*#__PURE__*/_jsx(Tooltip, {
      title: t('In Progress'),
      arrow: true,
      children: /*#__PURE__*/_jsx(Box, {
        sx: {
          height: 16,
          display: 'flex',
          alignItems: 'center'
        },
        children: /*#__PURE__*/_jsx(ProgressBar, {
          sx: {
            width: 40
          },
          progress: progress
        })
      })
    });
  });
};

var Completed = function Completed() {
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "Completed",
    "data-source-file": "status-bar.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: t('Complete'),
        arrow: true,
        children: /*#__PURE__*/_jsx(Box, {
          sx: {
            height: 16,
            display: 'flex',
            alignItems: 'center'
          },
          children: /*#__PURE__*/_jsx(ProgressBar, {
            sx: {
              width: 40
            },
            color: "success",
            progress: 100
          })
        })
      });
    }
  });
};

var StatusBar = function StatusBar(_ref5) {
  var challenge = _ref5.challenge,
      onClick = _ref5.onClick,
      challengeLink = _ref5.challengeLink,
      replaceUrl = _ref5.replaceUrl;
  var expiresAt = challenge.expiresAt,
      remainingCompletionCount = challenge.remainingCompletionCount,
      memberRemainingCompletionCount = challenge.memberRemainingCompletionCount,
      multiComplete = challenge.multiComplete,
      inProgress = challenge.inProgress,
      availableForCompletion = challenge.availableForCompletion;
  var isComplete = checkIfComplete(challenge);
  var timeUntilExpiration = expiresAt ? getExpirationWithinWeek(parseISO(expiresAt), new Date()) : null;
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    sx: {
      display: 'flex',
      alignItems: 'center',
      zIndex: function zIndex(t) {
        return t.zIndex._2;
      },
      cursor: 'pointer'
    }
  }, onClick ? {
    onClick: onClick
  } : {
    component: RouterLink,
    replace: replaceUrl,
    to: challengeLink !== null && challengeLink !== void 0 ? challengeLink : '',
    color: 'inherit'
  }), {}, {
    "data-element": "Box",
    "data-component": "StatusBar",
    "data-source-file": "status-bar.tsx",
    children: [remainingCompletionCount !== null ? /*#__PURE__*/_jsx(CompletionWarning, {
      remainingCompletionCount: remainingCompletionCount
    }) : null, multiComplete && /*#__PURE__*/_jsx(MulticompleteInfo, {
      memberRemainingCompletionCount: memberRemainingCompletionCount
    }), timeUntilExpiration && !isComplete && /*#__PURE__*/_jsx(TimeUntilExpiration, {
      timeUntilExpiration: timeUntilExpiration
    }), availableForCompletion && inProgress && /*#__PURE__*/_jsx(ChallengeProgress, {
      challenge: challenge
    }), (!availableForCompletion || isComplete) && /*#__PURE__*/_jsx(Completed, {})]
  }));
};

export default StatusBar;